var _desc, _defs, _g, _clipPath, _clipPath2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIzziVerticalClaroLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "502ccd6d-7c04-41dd-9b83-d04cf113cdde"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "8f5d054e-9423-4c53-8176-fc21d3caf88f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 1.33 419.22 242.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(242,112,33)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-116.63, -19.24)",
    d: "M 137.292969 38.480469 L 95.960938 38.480469 L 95.960938 -0.00390625 L 137.292969 -0.00390625 L 137.292969 38.480469",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 1.33 291.27 492.21)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(17,183,178)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-20.67, -206.45)",
    d: "M 41.332031 225.8125 L 0 225.8125 L 0 187.085938 L 41.332031 187.085938 L 41.332031 225.8125",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 1.33 661.04 837.11)",
    clipPath: "url(#CLIPPATH_5)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_5"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0 -0.38) translate(-298, -464.74)",
    d: "M 277 445 L 319 445 L 319 484.480469 L 277 484.480469 Z M 277 445",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(249,206,5)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-298, -465.12)",
    d: "M 318.667969 484.480469 L 277.332031 484.480469 L 277.332031 445.75 L 318.667969 445.75 L 318.667969 484.480469",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 1.33 788.6 594.88)",
    clipPath: "url(#CLIPPATH_6)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_6"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 -0.01 0.05) translate(-393.66, -283.5)",
    d: "M 373 264 L 414.328125 264 L 414.328125 303 L 373 303 Z M 373 264",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(214,20,109)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-393.67, -283.45)",
    d: "M 414.332031 302.8125 L 373 302.8125 L 373 264.085938 L 414.332031 264.085938 L 414.332031 302.8125",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 1.33 419.22 428.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-116.63, -159.15)",
    d: "M 137.292969 225.8125 L 95.960938 225.8125 L 95.960938 92.480469 L 137.292969 92.480469 L 137.292969 225.8125",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 1.33 661.44 656.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(253,254,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-298.29, -330.15)",
    d: "M 318.960938 396.8125 L 277.628906 396.8125 L 277.628906 263.480469 L 318.960938 263.480469 L 318.960938 396.8125",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 1.33 590.17 403.15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-244.98, -139.81)",
    d: "M 173.960938 92.480469 L 173.960938 53.8125 L 318.667969 53.8125 L 318.667969 92.480469 L 228.628906 187.085938 L 318.667969 187.085938 L 318.667969 225.8125 L 171.292969 225.8125 L 171.292969 187.085938 L 262.628906 92.480469 L 173.960938 92.480469",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 1.33 486.17 683.51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-166.98, -350.08)",
    d: "M 95.960938 302.75 L 95.960938 264.085938 L 240.667969 264.085938 L 240.667969 302.75 L 150.628906 397.355469 L 240.667969 397.355469 L 240.667969 436.082031 L 93.292969 436.082031 L 93.292969 397.355469 L 184.628906 302.75 L 95.960938 302.75",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 1.33 739.64 728.12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-356.93, -383.36)",
    d: "M 354.929688 382.707031 L 356.398438 382.707031 C 358.113281 382.707031 359.5 382.136719 359.5 380.746094 C 359.5 379.523438 358.601563 378.710938 356.644531 378.710938 C 355.828125 378.710938 355.257813 378.792969 354.929688 378.875 Z M 354.851563 390.289063 L 351.75 390.289063 L 351.75 376.914063 C 352.972656 376.671875 354.6875 376.507813 356.890625 376.507813 C 359.421875 376.507813 360.554688 376.914063 361.539063 377.488281 C 362.269531 378.058594 362.839844 379.117188 362.839844 380.421875 C 362.839844 381.890625 361.699219 383.03125 360.070313 383.523438 L 360.070313 383.6875 C 361.371094 384.175781 362.109375 385.152344 362.515625 386.945313 C 362.925781 388.984375 363.164063 389.800781 363.496094 390.289063 L 360.152344 390.289063 C 359.746094 389.800781 359.5 388.574219 359.089844 387.027344 C 358.847656 385.5625 358.03125 384.90625 356.320313 384.90625 L 354.851563 384.90625 Z M 346.609375 383.277344 C 346.609375 389.230469 351.019531 393.960938 357.050781 393.960938 C 362.925781 393.960938 367.242188 389.230469 367.242188 383.355469 C 367.242188 377.402344 362.925781 372.59375 356.96875 372.59375 C 351.019531 372.59375 346.609375 377.402344 346.609375 383.277344 Z M 370.667969 383.277344 C 370.667969 390.859375 364.71875 396.8125 356.96875 396.8125 C 349.308594 396.8125 343.191406 390.859375 343.191406 383.277344 C 343.191406 375.855469 349.308594 369.902344 356.96875 369.902344 C 364.71875 369.902344 370.667969 375.855469 370.667969 383.277344",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIzziVerticalClaroLogo);
export default __webpack_public_path__ + "static/media/izzi-vertical-claro-logo.89efa8cd4e254d061dc4ba51ed71836d.svg";
export { ForwardRef as ReactComponent };